import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../../redux/slices/header-slice.js';
import SubLinks from '../../components/header/SubLinks.jsx';
import { adminLinks } from '../../config/standard-links.js';
import OarForm from '../../components/admin-automations/OarForm.jsx';
import BackArrow from '../../components/common/BackArrow.jsx';

/**
 * Component for rendering the OAR automation page.
 * @returns {JSX.Element} OAR automation page component.
 */
const OarPage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setActiveTab('Admin'));

        return () => {
            dispatch(setActiveTab(null));
        };
    });

    return (
        <div>
            <SubLinks links={adminLinks} />
            <div className="newsc-container">
                <br />
                <br />
                <br />
                <div className="create-office-heading">
                    <BackArrow navigateTo={-1} />
                    <h2>OAR Automation</h2>
                </div>
                <br />
                <OarForm />
            </div>
        </div>
    );
};

export default OarPage;
